import { GridView } from './grid-view.js';
import { HoverState } from './hover-state.js';
import { InteractionHints } from './interaction-hints.js';
import { SelectionView } from './selection-view.js';

import type { ModelGrid } from '@cadstrom/sigma-engine-shared';

export type CadRendererStatusBarProps = {
	modelGrid: ModelGrid;
};

export function CadRendererStatusBar({ modelGrid }: CadRendererStatusBarProps) {
	return (
		<div className='grid h-7 grid-cols-[minmax(max-content,1fr)_auto_minmax(max-content,1fr)] items-center gap-6 border-t border-gray-a4 bg-gray-1 p-1 tabular-nums'>
			<div className='flex items-center gap-3 overflow-hidden'>
				<GridView modelGrid={modelGrid} />

				<div className='w-px self-stretch bg-gray-a4' />

				<InteractionHints />
			</div>

			<HoverState />

			<SelectionView modelGrid={modelGrid} />
		</div>
	);
}
